import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

export default class UserParserController {
  constructor(options) {
    console.debug("UserParserController", { that: this, options });
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.bus = new ServiceBus();
  }

  submit() {
    const $ctrl = this;
      const UserNameIn = ($ctrl.userNames || "NO_USERID").split(/[\s,]+/gi).filter(userName => !!userName);
    const request = {
      UserNameIn,
      take: 500,
      fields: "UserName"
    };
    $ctrl.bus.send("QueryUsers.json", request).then(({ data }) => {
      $ctrl.$close(data.results.map(p => p.id));
    });
  }

  $onDestroy() {
    this.bus.dispose();
  }
}
